export default __webpack_public_path__ + "assets/images/0125bcece6d1fd7775928838ed29dba9.jpg";